import { render, staticRenderFns } from "./user-create.vue?vue&type=template&id=06f8a2d8&scoped=true&"
import script from "./user-create.vue?vue&type=script&lang=js&"
export * from "./user-create.vue?vue&type=script&lang=js&"
import style0 from "./user-create.vue?vue&type=style&index=0&id=06f8a2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8a2d8",
  null
  
)

export default component.exports